/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Fast_Panda_LurkInputs */

const en_dry_fast_panda_lurk = /** @type {(inputs: Dry_Fast_Panda_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

const de_dry_fast_panda_lurk = /** @type {(inputs: Dry_Fast_Panda_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderlich`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Dry_Fast_Panda_LurkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dry_fast_panda_lurk = /** @type {((inputs?: Dry_Fast_Panda_LurkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Fast_Panda_LurkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dry_fast_panda_lurk(inputs)
	return de_dry_fast_panda_lurk(inputs)
});